export default __webpack_public_path__ + "static/Poison_Grenade-76a6242c25059756ec565489782ee5b0.png";